import { FunctionComponent, PropsWithChildren, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

export const Overlay: FunctionComponent<PropsWithChildren<{}>> = ({
  children,
}) => {
  const root = useRef(document.getElementById('overlays'));
  const el = useRef(document.createElement('div'));

  useEffect(() => {
    root.current.appendChild(el.current);

    return () => {
      root.current.removeChild(el.current);
    };
  }, []);

  return ReactDOM.createPortal(children, el.current);
};

export default Overlay;
